var _circle, _circle2, _g, _circle3, _g2, _circle4, _g3, _circle5, _g4, _circle6, _g5, _circle7, _g6;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgJupiter(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 582,
    height: 582,
    viewBox: "0 0 582 582",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 291,
    cy: 291,
    r: 291,
    fill: "#ECAD7A"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_0_8556",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 582,
    height: 582
  }, _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 291,
    cy: 291,
    r: 291,
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_0_8556)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38 294C44.6274 294 50 299.373 50 306C50 312.627 44.6274 318 38 318H-118C-124.627 318 -130 312.627 -130 306C-130 299.373 -124.627 294 -118 294H38ZM258 294C264.627 294 270 299.373 270 306C270 312.627 264.627 318 258 318H180L180 318.01C173.605 318.272 168.5 323.54 168.5 330C168.5 336.46 173.605 341.728 180 341.99L180 342H340C346.627 342 352 347.373 352 354C352 360.627 346.627 366 340 366H83C76.3726 366 71 360.627 71 354C71 347.373 76.3726 342 83 342H132C138.627 342 144 336.627 144 330C144 323.373 138.627 318 132 318H102C95.3726 318 90 312.627 90 306C90 299.373 95.3726 294 102 294H258ZM53 390C59.6274 390 65 395.373 65 402C65 408.627 59.6274 414 53 414H-20C-26.6274 414 -32 408.627 -32 402C-32 395.373 -26.6274 390 -20 390H53ZM340 390C346.627 390 352 395.373 352 402C352 408.627 346.627 414 340 414H267C260.373 414 255 408.627 255 402C255 395.373 260.373 390 267 390H340ZM604 402C604 395.373 598.627 390 592 390H426C419.373 390 414 395.373 414 402C414 408.627 419.373 414 426 414H592C598.627 414 604 408.627 604 402ZM414 318C420.627 318 426 323.373 426 330C426 336.627 420.627 342 414 342H405C398.373 342 393 347.373 393 354C393 360.627 398.373 366 405 366H662C668.627 366 674 360.627 674 354C674 347.373 668.627 342 662 342H462L462 341.99C455.605 341.728 450.5 336.46 450.5 330C450.5 323.54 455.605 318.272 462 318.01L462 318H486C492.627 318 498 312.627 498 306C498 299.373 492.627 294 486 294H330C323.373 294 318 299.373 318 306C318 312.627 323.373 318 330 318H414ZM712 306C712 299.373 706.627 294 700 294H544C537.373 294 532 299.373 532 306C532 312.627 537.373 318 544 318H700C706.627 318 712 312.627 712 306Z",
    fill: "#F0D29F"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_0_8556",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 582,
    height: 582
  }, _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 291,
    cy: 291,
    r: 291,
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_0_8556)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M159 402C159 395.373 153.627 390 147 390H118C111.373 390 106 384.627 106 378C106 371.373 111.373 366 118 366H219C225.627 366 231 371.373 231 378C231 384.627 225.627 390 219 390H216L215.999 390.01C209.604 390.273 204.5 395.54 204.5 402C204.5 408.46 209.604 413.727 215.999 413.99L216 414H219C225.627 414 231 419.373 231 426C231 432.627 225.627 438 219 438H143C136.373 438 131 432.627 131 426C131 419.373 136.373 414 143 414H147C153.627 414 159 408.627 159 402Z",
    fill: "#D86534"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_0_8556",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 582,
    height: 582
  }, _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 291,
    cy: 291,
    r: 291,
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_0_8556)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M466 54C459.373 54 454 59.3726 454 66C454 72.6274 459.373 78 466 78H622C628.627 78 634 72.6274 634 66C634 59.3726 628.627 54 622 54H466ZM246 54C239.373 54 234 59.3726 234 66C234 72.6274 239.373 78 246 78H324L324 78.0102C330.395 78.2721 335.5 83.5399 335.5 90C335.5 96.4601 330.395 101.728 324 101.99L324 102H164C157.373 102 152 107.373 152 114C152 120.627 157.373 126 164 126H421C427.627 126 433 120.627 433 114C433 107.373 427.627 102 421 102H372C365.373 102 360 96.6274 360 90C360 83.3726 365.373 78 372 78H402C408.627 78 414 72.6274 414 66C414 59.3726 408.627 54 402 54H246ZM451 150C444.373 150 439 155.373 439 162C439 168.627 444.373 174 451 174H524C530.627 174 536 168.627 536 162C536 155.373 530.627 150 524 150H451ZM164 150C157.373 150 152 155.373 152 162C152 168.627 157.373 174 164 174H237C243.627 174 249 168.627 249 162C249 155.373 243.627 150 237 150H164ZM-100 162C-100 155.373 -94.6274 150 -88 150H78C84.6274 150 90 155.373 90 162C90 168.627 84.6274 174 78 174H-88C-94.6274 174 -100 168.627 -100 162ZM90 78C83.3726 78 78 83.3726 78 90C78 96.6274 83.3726 102 90 102H99C105.627 102 111 107.373 111 114C111 120.627 105.627 126 99 126H-158C-164.627 126 -170 120.627 -170 114C-170 107.373 -164.627 102 -158 102H42L41.9996 101.99C48.3953 101.728 53.5 96.4601 53.5 90C53.5 83.5399 48.3953 78.2721 41.9996 78.0102L42 78H18C11.3726 78 6 72.6274 6 66C6 59.3726 11.3726 54 18 54H174C180.627 54 186 59.3726 186 66C186 72.6274 180.627 78 174 78H90ZM-208 66C-208 59.3726 -202.627 54 -196 54H-40C-33.3726 54 -28 59.3726 -28 66C-28 72.6274 -33.3726 78 -40 78H-196C-202.627 78 -208 72.6274 -208 66Z",
    fill: "#DC8E61"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask3_0_8556",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 582,
    height: 582
  }, _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 291,
    cy: 291,
    r: 291,
    fill: "white"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3_0_8556)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M624 438C617.373 438 612 443.373 612 450C612 456.627 617.373 462 624 462H780C786.627 462 792 456.627 792 450C792 443.373 786.627 438 780 438H624ZM404 438C397.373 438 392 443.373 392 450C392 456.627 397.373 462 404 462H482L482 462.01C488.395 462.272 493.5 467.54 493.5 474C493.5 480.46 488.395 485.728 482 485.99L482 486H322C315.373 486 310 491.373 310 498C310 504.627 315.373 510 322 510H579C585.627 510 591 504.627 591 498C591 491.373 585.627 486 579 486H530C523.373 486 518 480.627 518 474C518 467.373 523.373 462 530 462H560C566.627 462 572 456.627 572 450C572 443.373 566.627 438 560 438H404ZM609 534C602.373 534 597 539.373 597 546C597 552.627 602.373 558 609 558H682C688.627 558 694 552.627 694 546C694 539.373 688.627 534 682 534H609ZM322 534C315.373 534 310 539.373 310 546C310 552.627 315.373 558 322 558H395C401.627 558 407 552.627 407 546C407 539.373 401.627 534 395 534H322ZM58 546C58 539.373 63.3726 534 70 534H236C242.627 534 248 539.373 248 546C248 552.627 242.627 558 236 558H70C63.3726 558 58 552.627 58 546ZM248 462C241.373 462 236 467.373 236 474C236 480.627 241.373 486 248 486H257C263.627 486 269 491.373 269 498C269 504.627 263.627 510 257 510H0C-6.62744 510 -12 504.627 -12 498C-12 491.373 -6.62744 486 0 486H200L200 485.99C206.395 485.728 211.5 480.46 211.5 474C211.5 467.54 206.395 462.272 200 462.01L200 462H176C169.373 462 164 456.627 164 450C164 443.373 169.373 438 176 438H332C338.627 438 344 443.373 344 450C344 456.627 338.627 462 332 462H248ZM-50 450C-50 443.373 -44.6274 438 -38 438H118C124.627 438 130 443.373 130 450C130 456.627 124.627 462 118 462H-38C-44.6274 462 -50 456.627 -50 450Z",
    fill: "#D89D6D"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask4_0_8556",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 582,
    height: 582
  }, _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 291,
    cy: 291,
    r: 291,
    fill: "white"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask4_0_8556)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M177 222C183.627 222 189 227.373 189 234C189 240.627 183.627 246 177 246H167C160.373 246 155 251.373 155 258C155 264.627 160.373 270 167 270H256C262.627 270 268 264.627 268 258C268 251.373 262.627 246 256 246H246L245.999 245.99C239.604 245.727 234.5 240.46 234.5 234C234.5 227.54 239.604 222.273 245.999 222.01L246 222H311C317.627 222 323 216.627 323 210C323 203.373 317.627 198 311 198H112C105.373 198 100 203.373 100 210C100 216.627 105.373 222 112 222H177ZM131 258C131 251.373 125.627 246 119 246H57C50.3726 246 45 251.373 45 258C45 264.627 50.3726 270 57 270H119C125.627 270 131 264.627 131 258ZM9 246C15.6274 246 21 251.373 21 258C21 264.627 15.6274 270 9 270H-19C-25.6274 270 -31 264.627 -31 258C-31 251.373 -25.6274 246 -19 246H9ZM484 258C484 251.373 478.627 246 472 246H304C297.373 246 292 251.373 292 258C292 264.627 297.373 270 304 270H472C478.627 270 484 264.627 484 258ZM548 246C554.627 246 560 251.373 560 258C560 264.627 554.627 270 548 270H520C513.373 270 508 264.627 508 258C508 251.373 513.373 246 520 246H548ZM513 210C513 203.373 507.627 198 501 198H359C352.373 198 347 203.373 347 210C347 216.627 352.373 222 359 222H501C507.627 222 513 216.627 513 210ZM599 198C605.627 198 611 203.373 611 210C611 216.627 605.627 222 599 222H549C542.373 222 537 216.627 537 210C537 203.373 542.373 198 549 198H599ZM52 210C52 203.373 46.6274 198 40 198H12C5.37258 198 0 203.373 0 210C0 216.627 5.37258 222 12 222H40C46.6274 222 52 216.627 52 210Z",
    fill: "#D89D6D"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask5_0_8556",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 582,
    height: 582
  }, _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 291,
    cy: 291,
    r: 291,
    fill: "white"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask5_0_8556)"
  }, /*#__PURE__*/React.createElement("rect", {
    opacity: 0.0775757,
    x: 291,
    width: 292,
    height: 582,
    fill: "black"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgJupiter);
export default __webpack_public_path__ + "static/media/Jupiter.1816cbc89515aa06a6d7fd6b1e1f23bc.svg";
export { ForwardRef as ReactComponent };